/* Renders `**…**` spans (exact menu and button names) in bold. Text only, so
 * nothing in a recipe can inject markup. */
export const Emphasis = ({ text }: { text: string }) => (
  <>
    {text.split('**').map((part, index) =>
      index % 2 === 1 ? (
        <strong key={index} className='font-medium text-foreground'>
          {part}
        </strong>
      ) : (
        part
      ),
    )}
  </>
);
